const snakeToCamel = s => s.replace(/([-_][a-z])/ig, $1 => $1.toUpperCase()
  .replace('-', '')
  .replace('_', ''))

export default snakeToCamel
